export default __webpack_public_path__ + "static/media/sacl.dbc9034a.svg";